import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import CrmJwtService from 'app/services/crm/CrmJwtService';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { hideMessage, showMessage } from 'app/store/fuse/messageSlice';

import { setUserData, logoutUser } from './store/crmUserSlice';

class AuthCrm extends Component {
    state = {
        waitAuthCheck: true,
    };

    componentDidMount() {
        return Promise.all([
            // Comment the lines which you do not use
            this.jwtCheck(),
        ]).then(() => {
            this.setState({ waitAuthCheck: false });
        });
    }

    jwtCheck = () =>
        new Promise((resolve) => {
            CrmJwtService.on('onAutoLoginCRM', () => {
                // this.props.showMessage({ message: 'Logging in with JWT' });

                /**
                 * Sign in and retrieve user data from Api
                 */
                CrmJwtService
                    .signUserPayloadDecoded(CrmJwtService.getAccessToken())
                    .then((user) => {
                        this.props.setUserData(user);
                        resolve();
                    })
                    .catch((error) => {
                        resolve();
                    });
            });

            CrmJwtService.on('onRefreshTokenCRM', () => {
                CrmJwtService
                    .signUserRefreshToken(CrmJwtService.getRefreshAccessToken())
                    .then((user) => {
                        this.props.setUserData(user);
                        resolve();
                    })
                    .catch((error) => {
                        resolve();
                    });
            });

            CrmJwtService.on('onAutoLogoutCRM', (message) => {
                if (message) {
                    this.props.showMessage({ message });
                }

                this.props.logout();

                resolve();
            });

            CrmJwtService.on('onNoAccessTokenCRM', () => {
                this.props.logout();
                resolve();
            });

            CrmJwtService.init();

            return Promise.resolve();
        });
    render() {
        return this.state.waitAuthCheck ? <FuseSplashScreen /> : <>{this.props.children}</>;
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            logout: logoutUser,
            setUserData,
            showMessage,
            hideMessage,
        },
        dispatch
    );
}

export default connect(null, mapDispatchToProps)(AuthCrm);
